import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import AdminOrderDetails from "./AdminOrderDetails";

const AdminOrderDetailsPage = () => {
  const { orderId } = useParams();
  const navigate = useNavigate();
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);

  const BASE_URL =
    process.env.REACT_APP_API_BASE_URL || "http://localhost:5000";

  useEffect(() => {
    fetch(`${BASE_URL}/api/admin/orders/${orderId}`, {
      credentials: "include",
    })
      .then((res) => {
        if (!res.ok) throw new Error("Order not found");
        return res.json();
      })
      .then((data) => setOrder(data))
      .catch(() => navigate("/admin/orders"))
      .finally(() => setLoading(false));
  }, [orderId, BASE_URL, navigate]);

  if (loading) {
    return (
      <div className="p-6 text-center text-gray-500">
        Loading order details…
      </div>
    );
  }

  return (
    <div className="p-6">
      <button
        onClick={() => navigate(-1)}
        className="mb-4 text-sm text-blue-600 hover:underline"
      >
        ← Back to Orders
      </button>

      <AdminOrderDetails order={order} />
    </div>
  );
};

export default AdminOrderDetailsPage;
